// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const CriteriaFooter = props =>
    <div className='criteria-footer'>
        <div className='asterisk-before'>
            <FormattedMessage id='INDICATES_REQUIRED_FIELD'/>
        </div>
        <div className='button-group'>
            <button
                className='secondary-button'
                onClick={props.onCriteriaReset}
                type='submit'
            >
                <FormattedMessage id='RESET'/>
            </button>
            <button
                className='primary-button'
                disabled={!props.canRunReport}
                onClick={props.onRunReport}
                type='button'
            >
                <FormattedMessage id='EXECUTE'/>
            </button>
        </div>
    </div>;

CriteriaFooter.displayName = 'CriteriaFooter';
CriteriaFooter.propTypes = {
    canRunReport: PropTypes.bool.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onRunReport: PropTypes.func.isRequired
};

export default CriteriaFooter;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/components/report-criteria/criteria-footer.js